import React from 'react';
// import PropTypes, { string } from 'prop-types';
import '../Input.scss';
interface CustomProps {
  default?: string;
  name?: string;
  placeholder?: string;
  autoComplete?: string;
  label?: string;
  gap?: 'sm' | 'md' | 'lg' | 'no';
  size?: 'lg' | 'sm';
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  className?: string;
  suggestions?: React.ReactNode;
}

interface CustomState {
  value?: string;
  showPassword: boolean;
}

class PasswordInput extends React.Component<CustomProps, CustomState> {
  static defaultProps: Partial<CustomProps> = {
    default: '',
    name: '',
    label: '',
    placeholder: '',
    gap: 'md',
    size: 'sm',
    onChange: () => {
      return;
    },
    error: '',
    disabled: false,
    suggestions: null,
  };
  constructor(props: CustomProps) {
    super(props);
    this.state = {
      value: props.default,
      showPassword: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps: CustomProps) {
    if (prevProps.default !== this.props.default) {
      this.updateDefault();
    }
  }

  updateDefault() {
    // console.log('2. this.props.default(PasswordInput): ', this.props.default);
    if (this.props.default !== undefined) {
      this.setState({ value: this.props.default });
      this.props.onChange(this.props.default);
    }
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  handleChange(e: { target: any }) {
    const { value } = e.target;
    this.setState({ value });
    this.props.onChange(value);
  }

  render() {
    const {
      size,
      label,
      placeholder,
      name,
      gap,
      error,
      disabled,
      autoComplete,
      className,
      suggestions,
    } = this.props;
    const extraClassesInput: string[] = [];
    if (size === 'lg') extraClassesInput.push('Input__field--lg');
    const extraClasses = extraClassesInput.join(' ');
    const inputIdCandidate = name || label || placeholder || '';
    const inputId = inputIdCandidate
      .toLowerCase()  
      .split(' ')
      .join('-');
    return (
      <div className={`Input Input--gap-${gap}`}>
        {label && (
          // <label className="Input__label" htmlFor={inputId}>
          <label className="block pb-1 text-sm font-medium" htmlFor={inputId}>
            {label}
            {suggestions}
          </label>
        )}
        <div className="relative">
             <input
          id={inputId}
          // className={`Input__field ${extraClasses}`}
          // className="w-full focus:outline-none font-light border-b border-muted/50"
          className={`form-control ${className ? className : ''}`}
          type={this.state.showPassword ? "text" : "password"}
          placeholder={placeholder}
          onChange={this.handleChange}
          value={this.state.value}
          disabled={disabled}
          autoComplete={autoComplete}
        />
      
          {
            this.state.value && (
              <button 
                onClick={this.togglePasswordVisibility} 
                type="button" 
                className="absolute right-5 top-0 bottom-0 my-auto"
              >
                {this.state.showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
                ) : (
              
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            ) 
          }
  
        </div>

        {error && <span className="Input__error">{error}</span>}
      </div>
    );
  }
}

// PasswordInput.propTypes = {
//   default: PropTypes.string,
//   name: PropTypes.string,
//   placeholder: PropTypes.string,
//   label: PropTypes.string,
//   gap: PropTypes.oneOf(['sm', 'md', 'lg']),
//   size: PropTypes.oneOf(['lg', 'sm']),
//   onChange: PropTypes.func,
//   error: PropTypes.string,
//   disabled: PropTypes.bool,
// };

// PasswordInput.defaultProps = {
//   default: '',
//   name: '',
//   label: '',
//   placeholder: '',
//   gap: 'md',
//   size: 'sm',
//   onChange: () => {},
//   error: '',
//   disabled: false,
// };

export default PasswordInput;
